import { createFileRoute } from '@tanstack/react-router'
import { GoldCreditTransactionsTable } from '@/features/gold-credit-transactions'

export const Route = createFileRoute(
  '/_authenticated/wallet/gold-creadit-transactions'
)({
  component: GoldCreditTransactionsPage,
})

function GoldCreditTransactionsPage() {
  return <GoldCreditTransactionsTable />
}
